module.exports = __webpack_public_path__ + "img/mzc_credit_3months.20c51da9.png";